import { pm } from '@renderer/modules/api/pm';
import type { ApiResponse, StatusPayload } from '@renderer/modules/types';

export async function subscribe(slug: string): Promise<ApiResponse<{ tokenIds: string[] }>> {
  return pm.subscribe({ slug });
}

export function onStatus(cb: (payload: StatusPayload) => void): void {
  pm.onStatus(cb);
}

export function onOrderbook(cb: (text: string) => void): void {
  pm.onOrderbook(cb);
}

export async function refreshOrderbook(): Promise<ApiResponse> {
  return pm.refreshOrderbook();
}

export function log(line: unknown): void {
  pm.log(line);
}


